import { render, staticRenderFns } from "./ChatAssignmentTextEditor.vue?vue&type=template&id=676052a6&scoped=true&"
import script from "./ChatAssignmentTextEditor.vue?vue&type=script&lang=js&"
export * from "./ChatAssignmentTextEditor.vue?vue&type=script&lang=js&"
import style0 from "./ChatAssignmentTextEditor.vue?vue&type=style&index=0&id=676052a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676052a6",
  null
  
)

export default component.exports